export enum TaskTypeEnum {
  Questionnaire = 'questionnaire',
  Course = 'course',
  Quiz = 'quiz',
  Announcement = 'announcement',
  Live = 'live',
  Enroll = 'enroll',
  Interview = 'interview',
  Waggle = 'waggle',
  Pdf = 'pdf',
  Video = 'video',
  Exercise = 'exercise',
}
